import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

import { deleteOption } from "../../services/option";
import { IIndicators } from "../../types/indicator";

const useDeleteOption = (indicator: IIndicators) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: deleteOption,
        onMutate: () => {
            indicator.setIsProcessRunning(true);
            indicator.setIsServiceError(null);
        },
        onSuccess: (status) => {
            if (status === 200) {
                queryClient.invalidateQueries({ queryKey: ["question-options"] });
                indicator.setIsProcessRunning(false);
                indicator.setIsServiceError(null);
                toast.success("Action deleted successfully!");
            }
        },
        onError: (error: any) => {
            indicator.setIsProcessRunning(false);
            indicator.setIsServiceError(error.response?.data?.message);
            toast.error(error.response?.data?.message);
        }
    });
};

export default useDeleteOption;